import { Outlet } from 'react-router-dom';

import { OffsetScrollListsProvider } from '@/shared/legacy/contexts/OffsetScrollListsContext';
import { SidebarOverlayFixedProvider } from '@/shared/legacy/contexts/SidebarOverlayFixedContext';
import { NavBar } from 'components/ui/organisms/NavBar';
import Sidebar from 'components/ui/organisms/Sidebar/Sidebar';
import { useStyles } from './RobinJrLayout.styles';

export const RobinJrLayout = () => {
  const classes = useStyles();

  return (
    <OffsetScrollListsProvider>
      <SidebarOverlayFixedProvider>
        <div css={classes.root}>
          <Sidebar />

          <div css={classes.content}>
            <div css={classes.header}>
              <NavBar />
            </div>
            <div css={classes.body}>
              <Outlet />
            </div>
          </div>
        </div>
      </SidebarOverlayFixedProvider>
    </OffsetScrollListsProvider>
  );
};
